export enum EMaritalStatus {
    SOLTEIRO = 'SOLTEIRO',
    CASADO = 'CASADO',
    DIVORCIADO = 'DIVORCIADO',
    VIUVO = 'VIUVO',
    UNIAO_ESTAVEL = 'UNIAO_ESTAVEL',
    OUTRO = 'OUTRO',
}
